import {
  LOW_INVENTORY_REQUEST,
  LOW_INVENTORY_SUCCESS,
  LOW_INVENTORY_FAIL,
  INVENTORY_MFG_REQUEST,
  INVENTORY_MFG_SUCCESS,
  INVENTORY_MFG_FAIL,
  INVENTORY_SUMMARY_REQUEST,
  INVENTORY_SUMMARY_SUCCESS,
  INVENTORY_SUMMARY_FAIL
} from '../constants/reportConstants'

export const lowInventoryReducer = (state = { lowinventory: [] }, action) => {
  switch (action.type) {
    case LOW_INVENTORY_REQUEST:
      return { ...state, loading: true }

    case LOW_INVENTORY_SUCCESS:
      return {
        loading: false,
        error: false,
        lowinventory: action.payload.lowreport,
        lowpages: action.payload.lowpages,
        lowpage: action.payload.lowpage,
        lowcount: action.payload.lowcount
      }
    case LOW_INVENTORY_FAIL:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}

export const inventoryMfgReducer = (state = { inventorymfg: [] }, action) => {
  switch (action.type) {
    case INVENTORY_MFG_REQUEST:
      return { ...state, loading: true }

    case INVENTORY_MFG_SUCCESS:
      return {
        loading: false,
        error: false,
        inventorymfg: action.payload.inventorymfg,
        pagesmfg: action.payload.pagesmfg,
        pagemfg: action.payload.pagemfg,
        countmfg: action.payload.countmfg
      }
    case INVENTORY_MFG_FAIL:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}

export const inventorySummaryReducer = (
  state = { inventorysummary: [] },
  action
) => {
  switch (action.type) {
    case INVENTORY_SUMMARY_REQUEST:
      return { ...state, loading: true }

    case INVENTORY_SUMMARY_SUCCESS:
      return {
        loading: false,
        error: false,
        inventorysummary: action.payload.inventorysummary,
        pagessummary: action.payload.pagessummary,
        pagesummary: action.payload.pagesummary,
        countsummary: action.payload.countsummary
      }
    case INVENTORY_SUMMARY_FAIL:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}
